import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { EmailItemResponse } from "./../typings/index";
import { ListarFiltroEmailQuery } from "core/features/relatorios/typings";
import { PaginateResult } from 'core/resources/types/shared';

export function useRelatoriosEmails(filtro: ListarFiltroEmailQuery) {
  return useQuery<PaginateResult<EmailItemResponse>, AxiosError>(
    [`/v1/relatorios/emails`, filtro],
    async () => {
      const { data } = await http.get<PaginateResult<EmailItemResponse>>(
        "/v1/relatorios/emails",
        { params: filtro }
      );

      return data;
    }
  );
}
